import { render, staticRenderFns } from "./PublicHeader.vue?vue&type=template&id=37491240&scoped=true&"
import script from "./PublicHeader.vue?vue&type=script&lang=js&"
export * from "./PublicHeader.vue?vue&type=script&lang=js&"
import style0 from "./PublicHeader.vue?vue&type=style&index=0&id=37491240&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37491240",
  null
  
)

export default component.exports